import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { combineLatest, Subscription } from "rxjs";
import { Context } from "../../../models/context";

type ActionTab = "bots" | "external-links";

@Component({
  selector: "app-actions-page",
  templateUrl: "./actions.component.html",
  styleUrls: ["./actions.component.scss"],
})
export class ActionsComponent implements OnInit, OnDestroy {

  public context: Context = new Context();
  public serviceId: string;
  public activeTab: ActionTab = "bots";
  public tabs = [
    { id: "bots", name: "Bots" },
    { id: "external-links", name: "External Links" },
  ];
  public tabBaseUrl: string;

  private subscription = new Subscription();

  constructor(private route: ActivatedRoute, private router: Router) { }

  public ngOnInit(): void {
    this.subscription.add(
      combineLatest([
        this.route.paramMap,
        this.route.data,
        this.route.queryParamMap,
      ]).subscribe(([params, data, query]) => {
        this.serviceId = params.get("serviceId");
        if (this.serviceId) {
          this.tabBaseUrl = `/services/${this.serviceId}/actions`;
        }
        const tabParam = params.get("tab") || query.get("tab") || data?.defaultTab;
        this.setActiveTab(tabParam as string);
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public isActive(tab: ActionTab): boolean {
    return this.activeTab === tab;
  }

  private setActiveTab(tab?: string): void {
    const targetTab: ActionTab = tab === "external-links" ? "external-links" : "bots";
    this.activeTab = targetTab;

    if (!this.serviceId) {
      return;
    }

    const canonicalBase = `/services/${this.serviceId}/actions`;
    const targetCommands = ["/services", this.serviceId, "actions", targetTab];
    const currentUrl = this.router.url;
    const isOnCanonicalPath = currentUrl.startsWith(canonicalBase);
    const isBaseWithoutTab = currentUrl === canonicalBase;

    if (!isOnCanonicalPath || (!tab && isBaseWithoutTab)) {
      this.router.navigate(targetCommands, { replaceUrl: true });
    }
  }
}
